// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const View: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 18" enableBackground="new 0 0 24 18" xmlSpace="preserve" fill="currentColor">
<path d="M23.98,9c0.01-0.01,0.02-0.03,0.02-0.04l-0.08-0.05l-0.14-0.23C21.28,4.68,16.86,2.18,12,2.18c-4.95,0-9.44,2.6-11.92,6.73
	L0,8.96L0.02,9C0.02,9.01,0.01,9.03,0,9.04l0.08,0.05l0.14,0.23c2.5,4.01,6.93,6.51,11.78,6.51c4.95,0,9.44-2.6,11.92-6.73L24,9.04
	L23.98,9z M12,14.52c-4.25,0-8.13-2.11-10.44-5.51C3.87,5.6,7.74,3.48,12,3.48c4.25,0,8.13,2.11,10.44,5.51
	C20.13,12.4,16.25,14.52,12,14.52z"/>
<path d="M12.06,4.55c-2.54,0-4.6,1.99-4.6,4.45c0,2.46,2.06,4.45,4.6,4.45c2.54,0,4.6-1.99,4.6-4.45
	C16.67,6.54,14.6,4.55,12.06,4.55z M12.06,12.22c-1.87,0-3.38-1.45-3.38-3.22c0-1.78,1.51-3.22,3.38-3.22
	c1.87,0,3.38,1.45,3.38,3.22C15.44,10.78,13.93,12.22,12.06,12.22z"/>
</svg>;
};

export default React.memo(View);
